import { Component, OnInit } from '@angular/core';
import {CommonModule} from "@angular/common";
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../../auth/auth.service';
import { LayoutService } from '../../../shared/services/layout.service';
import { SpinnerComponent } from '../../../shared/components/spinner/spinner.component';
import { StorageService } from '../../../shared/services/storage.service';
import { Roles } from '../../../shared/models';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [CommonModule, TranslateModule, SpinnerComponent],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit {
  isLoading: boolean = false;
  user: any = {};
  Roles: Roles;
  
  constructor(
    private authService: AuthService,
    private layoutService: LayoutService,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
   this.layoutService.loading$.subscribe((loading) => {
      this.isLoading = loading;
    });
    this.user = this.storageService.getFromLocalOrSessionStorage('user') || {};
  }

  logout(){
    this.isLoading = true;
    this.authService.logOutApi().subscribe({
      next: (_) => {
        this.authService.logout();
      },
      error: (error: any) => {
        console.error(error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }
}
